import { AfterViewInit, Component, Inject, OnDestroy } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { NonRootToken } from '@frontend/sports/host-app/sports-product/feature/non-root-token';
import { CustomLoadingIndicatorService, ILoadingIndicatorHandler, LOADING_INDICATOR } from '@frontend/sports/loading-indicator-feature';

import { EpcotConfigService, EpcotModule } from '../common/epcot-config.service';

const loaderToken = 'PRINT';

@Component({
    selector: 'ms-print-loading-indicator',
    templateUrl: 'print-loading-indicator.html',
    providers: [{ provide: LOADING_INDICATOR, useValue: loaderToken }],
    standalone: false,
})
export class PrintLoadingIndicatorComponent implements AfterViewInit, OnDestroy {
    private loadingIndicator: ILoadingIndicatorHandler | null;

    constructor(
        public sitecore: Sitecore,
        @Inject(NonRootToken(CustomLoadingIndicatorService)) private loadingIndicatorService: CustomLoadingIndicatorService,
        private epcotConfigService: EpcotConfigService,
    ) {}

    ngAfterViewInit(): void {
        const isEpcotEnabled = this.epcotConfigService.isEnabled(EpcotModule.MyBetsBetSlip);
        const _loaderToken = isEpcotEnabled ? '' : loaderToken;
        this.loadingIndicator = this.loadingIndicatorService.start(_loaderToken, { delay: 0 });
    }

    ngOnDestroy(): void {
        if (this.loadingIndicator) {
            this.loadingIndicator.done();
        }
    }
}
